import { render, staticRenderFns } from "./InvestorModal.vue?vue&type=template&id=8c4c0008&scoped=true"
import script from "./InvestorModal.vue?vue&type=script&lang=js"
export * from "./InvestorModal.vue?vue&type=script&lang=js"
import style0 from "./InvestorModal.vue?vue&type=style&index=0&id=8c4c0008&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4c0008",
  null
  
)

export default component.exports